module.exports = __webpack_public_path__ + "static/media/pinata.04ee41cf.png";